//
//
//
//
//
//
//

import { mapMutations, mapState, mapGetters, mapActions } from "vuex";
// import axios from 'axios'
export default {
  name: "app",
  data() {
    return {
      show: false
    };
  }
};



// WEBPACK FOOTER //
// ./src/App.vue